<template>
  <div class="card" >
    <div class="card-body">
      <div class="change-product-seller">
        <h5 class="mb-0">DEWHOT DEPOT</h5>
        <p v-if="product_detail.distributor">          
          <strong>{{product_detail.distributor.company ? product_detail.distributor.company : ''}}</strong> <br/>
          <span v-if="product_detail.distributor.mobile">{{product_detail.distributor.mobile}} <br/></span>
          <span v-if="product_detail.distributor.email">{{product_detail.distributor.email}} <br/></span>
        </p>
         <vue-autosuggest
            :suggestions="distributorSuggestions"
            :input-props="{class:'form-control', id:'autosuggest_distributor_input', placeholder:'Change Depot'}"
            @input="onChangeDistributorInput"
            @selected="selectDistributorHandler"
            @click="onChangeDistributorInput"
            :getSuggestionValue="distributorSuggestionsValue"
          >  
          <template slot-scope="{suggestion}">
            <span class="my-suggestion-item">{{ (suggestion.item.company ? suggestion.item.company :  suggestion.item.fname) }}</span>
          </template>
        </vue-autosuggest>
        <p class="mt-2 mb-0"> <em>Cant find? <router-link :to="{ name: 'SuperadminCustomersAdd', query: { redirect: 'SuperadminRegisteredProductEdit', id: $route.params.id }}">Add depot</router-link></em></p>
        <button class="btn btn-primary rounded mt-3" @click.prevent="updateDistributor()">Update</button> 
      </div>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  components: {
    VueAutosuggest
  },
  props: ['product_detail'],
  data() {
    return {

      distributorSuggestions: [
        {
          data:[]
        }
      ],

    }
  },
  methods:{

    onChangeDistributorInput: _.debounce(function(name){

      if(name == null) {
        name = document.getElementById('autosuggest_distributor_input').value;
      }

      const url = `${Env.baseUrl}/superadmin/users/suggest-user?type=distributor`;
      AuthApis.postApi(url, {
        name: name
      }).then(res => {
        this.distributorSuggestions[0].data = res.data.payload;
      }).catch(err => {
        console.log(err)
      })

    }, 800),



     selectDistributorHandler(obj) {
      this.product_detail.distributor_id = obj.item.id;
      this.product_detail.distributor = obj.item;
      this.distributorSuggestions[0].data = [];
    },

    distributorSuggestionsValue(obj) {
      return (obj.item.company ? obj.item.company : obj.item.fname );
    },
    
    updateDistributor() {
       const url = `${Env.baseUrl}/superadmin/users/update-user/${this.product_detail.id}`;
      AuthApis.postApi(url, {
        type: 'distributor',
        user_id: this.product_detail.distributor_id,
      }).then(res => {
        this.$toasted.global.success({
          message: res.data.message,
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
</script>